import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TicketDto } from 'src/app/models/Tickets/TicketDto';
import { TicketService } from 'src/app/services/tickets.service';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
@Component({
    selector: 'app-ticket-view',
    templateUrl: './ticket-view.component.html',
    styleUrl: './ticket-view.component.css',
    imports: [CommonModule, FormsModule, RouterModule]
})
export class TicketViewComponent {

  id: number = 0;
  userId: number = 0;
  userName: string = '';
  iccid: string = '';
  errorMessage: string = '';
  description: string = '';
  comment: string = '';
  statusId: string = '';
  statuses: string[] = [];


  constructor(private route: ActivatedRoute,
      private router: Router, private ticketService: TicketService) {

  }


  ngOnInit() {
    this.route.params.subscribe(params => {
      this.id = params['id']; // Access the 'id' parameter from the URL
     
    });

    //this.permissionsService.validateAccessLevels(this.idModule);
    this.ticketService.getTicketById(this.id).subscribe((data) => {
      
      if (data) {
        this.userId = data.userId || 0;
        this.userName = data.userName || '';
        this.iccid = data.iccid || '';
        this.errorMessage = data.error || '';
        this.description = data.description || '';
        this.comment = data.comment || '';
        this.statusId = data.statusId?.toString() || '';
      }
    });

    this.ticketService.getTicketsStatuses().subscribe((data) => {
      
      if (data) {
        this.statuses = data;
      }
    });
    //     }
    //   },
    //   (error) => {
    //     this.alert = {
    //       alertMessage: 'Unexpected error. Please try again later.',
    //       alertType: 'alert alert-danger',
    //       alertCenter: false,
    //       alerTitle: '',
    //       duration: 3000,
    //     };
    //     this.alertService.updateAlertState(this.alert);
    //   }
    // );
  }

  updateTicket() {

    const ticketData : TicketDto = {
      id: this.id,
      userId: this.userId,
      userName: this.userName,
      iccid: this.iccid,
      error: this.errorMessage,
      description: this.description,
      comment: this.comment,
      statusId: this.statusId
    } as TicketDto;

    this.ticketService.updateTicket(ticketData).subscribe(
      (response) => {
        if (response) {
          
          // Handle successful update, e.g., navigate back to the list or show a success message
          this.router.navigate(['/tickets']);
        }
      },
      (error) => {
        // Handle error, e.g., show an error message
        console.error('Error updating ticket:', error);
      }
    );

  }
}
